import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { NotificationService } from "../../services/notification.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { NotificationResponse } from "../../models/notification-response.model";
import { NotificationRequest } from "../../models/notification-request.model";
import { Notification } from "../../models/notification.model";

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.scss',
    standalone: false
})
export class NotificationsComponent implements OnInit, OnDestroy {
  tabIndex: number = 0;

  @Output() hide = new EventEmitter<any>();
  count: number = 0;
  loading: boolean = false;
  response: NotificationResponse = new NotificationResponse();
  request: NotificationRequest = new NotificationRequest();
  page: number = 1;
  isVisible: boolean = true;
  drawerWidth: string | number = 500;
  private updateCountSubscription!: Subscription;

  constructor(private notificationService: NotificationService, private router: Router) {
  }

  ngOnInit(): void {
    this.count = this.notificationService.count;
    this.updateCountSubscription = this.notificationService.updateCount$.subscribe(resp => {
      this.count = this.notificationService.count;
      this.getList();
    });
    this.getList();
    this.setDrawerWidth();
  }

  ngOnDestroy(): void {
    if (this.updateCountSubscription != null) {
      this.updateCountSubscription.unsubscribe();
    }
  }

  getList() {
    this.loading = true;
    this.notificationService.notifications(this.request).subscribe(resp => {
      this.response = resp;
      this.loading = false;
    })
  }

  tabChange(event: any) {
    this.tabIndex = event?.index;
    if (event?.index == 1) {
      this.request.isRead = false;
    }
    else {
      this.request.isRead = null!;
    }
    this.getList();
  }

  onHide() {
    this.hide.emit();
  }

  onMarkAllAsRead() {
    this.notificationService.setIsReadAll().subscribe(resp => {
      this.getList();
    });
  }

  changeTab(index: any) {
  }

  pageChange(event: any) {
    this.request.page = event-1;
    this.getList();
  }

  openItem(item: Notification) {
    this.notificationService.selectedItem = item;
    this.notificationService.showNotificationContent$.next(1);
    this.onHide();
  }

  setDrawerWidth(): void {
    this.drawerWidth = window.innerWidth < 768 ? '100%' : 500;
  }
}